import {useStyles} from '../../shared/hooks/styles';
import {DeviceSize} from '../../shared/theme/helpers';

export const GetStyles = (deviceSize: DeviceSize) =>
  useStyles(({mediaOnly, theme}) => {
    return {
      screen: {
        backgroundColor: theme.screen.container[deviceSize].backgroundColor,
      },
      sectionTitle: {
        marginTop: 40,
        marginBottom: 30,
      },
      contentTextWrapper: mediaOnly(DeviceSize.desktop, {marginBottom: 0}, {marginBottom: 30}),
      sectionContainer: {
        overflow: 'hidden',
        marginTop: 22,
        ...mediaOnly(DeviceSize.desktop, {paddingHorizontal: 24}, {paddingHorizontal: 16}),
      },
      contentWithRightImageContainer: mediaOnly(DeviceSize.desktop, {paddingBottom: 60}, {paddingBottom: 60}),
      contentWidthRightImageBackground: mediaOnly(DeviceSize.desktop, {}, {right: -24, bottom: -74}),
      featuresList: {},
      sectionDescription: {
        marginTop: 8,
      },
      contacts: {
        marginBottom: 20,
      },
      openBankButton: {
        ...mediaOnly(DeviceSize.desktop, {width: 557}),
      },
    };
  });
